<template>
   <div class="notifications">
      <NxtNotifications
         class="app__notifications"
         :notifications="notifications"
         @on-remove-notification="removeNotification"
      />
   </div>
</template>

<script>
import { NxtNotifications } from '@nxtpeople/nxt-styles';
import { mapState } from 'vuex';
export default {
   components: {
      NxtNotifications,
   },

   props: {},

   data() {
      return {};
   },

   created() {},

   mounted() {},

   computed: {
      ...mapState(['notifications']),
   },

   watch: {},

   methods: {
      removeNotification(notification_key) {
         this.$store.dispatch('removeNotification', { notification_key });
      },
   },
};
</script>

<style lang="scss" scoped>
.notifications {
   z-index: 100000;
   position: fixed;
   right: 1rem;
   bottom: 1rem;
   &::-webkit-scrollbar {
      visibility: hidden;
   }
}
</style>
